<template>
  <div class="zmtz_wrap">
    <navbar_ :Lucency="false" :isBlack="true" :activeIndex="''" />

    <div class="zmtz_container">
      <div class="step_box">
        <div class="text">1、打开谷歌浏览器，点击右上角三点，选择设置。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/1.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">
          2、进入设置后，点击左上叫三条杠再选择 “隐私设置和安全性”。
        </div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/2_1.png" />

          <img src="@/assets/h5/zmtz/2_2.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">3、找到 “网站设置” 并打开。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/3.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">4、打开网站设置受找到 “通知” 。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/4.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">5、打开通知后点击开启即可。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/5.png" />
        </div>
      </div>

      <div class="wran_text">特别注意：win10以上系统需打开系统通知</div>

      <div class="step_box">
        <div class="text">1、在系统开始菜单中，选择【设置】选项。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/6.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">2、在设置页面，选择【系统】设置项。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/7.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">3、在系统设置页面，选择【通知】选项。</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/8.png" />
        </div>
      </div>

      <div class="step_box">
        <div class="text">4、在通知设置页面，开启【通知】开关</div>

        <div class="img_box">
          <img src="@/assets/h5/zmtz/9.png" />
        </div>
      </div>
    </div>

    <footer_ />
  </div>
</template>

<script>
import navbar_ from "@/components/navbar/index.vue"; // 顶部导航
import footer_ from "@/components/footer/index.vue"; // 底部

export default {
  data() {
    return {};
  },
  components: {
    navbar_,
    footer_,
  },
};
</script>

<style lang="less" scoped>
.zmtz_wrap {
  padding-top: 60px;

  .zmtz_container {
    background: #050a1a;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    padding: 24px 80px 40px;

    .step_box {
      margin-top: 28px;

      &:first-child {
        margin-top: 0;
      }

      .text {
        text-align: center;
      }

      .img_box {
        width: 50%;
        margin: 18px auto 0;
        text-align: center;

        img {
          max-width: 100%;
        }
      }
    }

    .wran_text {
      margin-top: 56px;
      text-align: center;
    }
  }
}
</style>